import {
  fetchUiComponents,
  fetchUiComponentSpecs,
  fetchUiSidebarItems,
} from "@/services/uiApi";
import { hydrateUiComponents, replaceUiComponents } from "@/storage/uiComponentsRepository";
import {
  hydrateUiComponentSpecs,
  replaceUiComponentSpecs,
} from "@/storage/uiComponentSpecsRepository";
import {
  hydrateUiSidebarItems,
  replaceUiSidebarItems,
} from "@/storage/uiSidebarItemsRepository";
import {
  createScopedUiSyncTaskGroup,
  useScopedUiSync,
  type ScopedUiParams,
} from "@/hooks/useScopedUiStorage";

const SYNC_TASKS = [createScopedUiSyncTaskGroup([
  {
    fetch: fetchUiComponents,
    hydrate: hydrateUiComponents,
    replace: replaceUiComponents,
  },
  {
    fetch: fetchUiSidebarItems,
    hydrate: hydrateUiSidebarItems,
    replace: replaceUiSidebarItems,
  },
  {
    fetch: fetchUiComponentSpecs,
    hydrate: hydrateUiComponentSpecs,
    replace: replaceUiComponentSpecs,
  },
])];

export function useInterfaceBuilderStorageSync(params: ScopedUiParams): void {
  useScopedUiSync(params, SYNC_TASKS);
}
